"use strict";

require("@patsnap-biz/list/lib/style");
require("@patsnap-biz/header-dropdown/lib/style");
require("@patsnap-biz/header-widget/lib/style");
require("./select_language.scss");
require("@patsnap-ui/icon/assets/solid/DropdownOpen.svg");
require("@patsnap-ui/icon/assets/solid/DropdownClose.svg");
require("@patsnap-ui/icon/assets/solid/DropdownRight.svg");
require("@patsnap-ui/icon/assets/solid/TranslateEnglish.svg");
require("@patsnap-ui/icon/assets/solid/tick.svg");